<template>
  <div>
    <AppMenuLateral :items="items" />
    <div class="wbs-side-menu-page">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import AppMenuLateral from "../components/layout/AppMenuLateral.vue";

function linksMenuLateral() {
  let items = [
    {
      text: "Menu",
      header: true
    },
    {
      text: "Dispositivos",
      icon: "mdi mdi-server",
      route: "/administrativo/dispositivos",
      id: "menu-dispositivos"
    },
    {
      text: "Armazenamentos",
      icon: "mdi mdi-harddisk",
      route: "/administrativo/armazenamentos",
      id: "menu-armazenamentos"
    },
    {
      text: "Licença",
      icon: "mdi-license",
      route: "/administrativo/licencas",
      id: "menu-licenca"
    }
  ];

  return items;
}

export default {
  components: { AppMenuLateral },
  data() {
    return {
      items: linksMenuLateral()
    };
  }
};
</script>

<style lang="sass"></style>
